import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page_header d-block"
}
const _hoisted_2 = { class: "stepsContainer" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "activeCircle" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "activeCircle" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "activeCircle" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "activeCircle" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "activeCircle" }, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "formContainer h-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_general_step = _resolveComponent("general-step")!
  const _component_garment_layers_step = _resolveComponent("garment-layers-step")!
  const _component_genders_step = _resolveComponent("genders-step")!
  const _component_properties_step = _resolveComponent("properties-step")!
  const _component_values_step = _resolveComponent("values-step")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.model)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.model.identifier)
            ? (_openBlock(), _createBlock(_component_localized_text, {
                key: 0,
                type: "h1",
                localizedKey: "New Garment Configuration",
                text: "New Garment Configuration"
              }))
            : (_openBlock(), _createBlock(_component_localized_text, {
                key: 1,
                type: "h1",
                localizedKey: "Edit Garment Configuration",
                text: "Edit Garment Configuration"
              })),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["step firstStep", {'active' : _ctx.activeStep == 0}])
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "{{name}}General",
                text: "{{name}}General",
                object: { name: _ctx.model.name ? _ctx.model.name + ' - ' : '' }
              }, null, 8, ["object"]),
              _hoisted_3
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["step", {'active' : _ctx.activeStep == 1}])
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Garment Layers",
                text: "Garment Layers"
              }),
              _hoisted_4
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["step", {'active' : _ctx.activeStep == 2}])
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Genders",
                text: "Genders"
              }),
              _hoisted_5
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["step", {'active' : _ctx.activeStep == 3}])
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Properties",
                text: "Properties"
              }),
              _hoisted_6
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["step", {'active' : _ctx.activeStep == 4}])
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Values",
                text: "Values"
              }),
              _hoisted_7
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.model)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.activeStep == 0)
            ? (_openBlock(), _createBlock(_component_general_step, {
                key: 0,
                modelValue: _ctx.model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
                onNext: _ctx.saveGarment
              }, null, 8, ["modelValue", "onNext"]))
            : (_ctx.activeStep == 1)
              ? (_openBlock(), _createBlock(_component_garment_layers_step, {
                  key: 1,
                  modelValue: _ctx.model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model) = $event)),
                  onInit: _ctx.init,
                  onNext: _ctx.next
                }, null, 8, ["modelValue", "onInit", "onNext"]))
              : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.garmentConfigurationPropertyLayers, (garmentConfigurationPropertyLayer, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (_ctx.activeStep == 2)
                ? (_openBlock(), _createBlock(_component_genders_step, {
                    key: 0,
                    identifier: _ctx.model.identifier,
                    index: index,
                    isLast: index == _ctx.model.garmentConfigurationPropertyLayers.length - 1,
                    modelValue: garmentConfigurationPropertyLayer,
                    "onUpdate:modelValue": ($event: any) => (_ctx.model.garmentConfigurationPropertyLayers[index] = $event),
                    onNext: _ctx.next,
                    onPrev: _ctx.prev,
                    onAddGendersToGarment: _ctx.addGendersToGarment
                  }, null, 8, ["identifier", "index", "isLast", "modelValue", "onUpdate:modelValue", "onNext", "onPrev", "onAddGendersToGarment"]))
                : _createCommentVNode("", true),
              (_ctx.activeStep == 3)
                ? (_openBlock(), _createBlock(_component_properties_step, {
                    key: 1,
                    identifier: _ctx.model.identifier,
                    index: index,
                    modelValue: garmentConfigurationPropertyLayer,
                    "onUpdate:modelValue": ($event: any) => (_ctx.model.garmentConfigurationPropertyLayers[index] = $event),
                    isLast: index == _ctx.model.garmentConfigurationPropertyLayers.length - 1,
                    onNext: _ctx.next,
                    onPrev: _ctx.prev
                  }, null, 8, ["identifier", "index", "modelValue", "onUpdate:modelValue", "isLast", "onNext", "onPrev"]))
                : _createCommentVNode("", true),
              (_ctx.activeStep == 4)
                ? (_openBlock(), _createBlock(_component_values_step, {
                    key: 2,
                    identifier: _ctx.model.identifier,
                    index: index,
                    modelValue: garmentConfigurationPropertyLayer,
                    "onUpdate:modelValue": ($event: any) => (_ctx.model.garmentConfigurationPropertyLayers[index] = $event),
                    onPrev: _ctx.prev
                  }, null, 8, ["identifier", "index", "modelValue", "onUpdate:modelValue", "onPrev"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}